import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStandTransformationHistoriesInputDto, StandTransformationHistoryCreateDto, StandTransformationHistoryDto, StandTransformationHistoryExcelDownloadDto, StandTransformationHistoryUpdateDto } from '../dtos/stand-transformation-history/models';

@Injectable({
  providedIn: 'root',
})
export class StandTransformationHistoryService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: StandTransformationHistoryCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDto>({
      method: 'POST',
      url: '/api/geographic/standTransformationHistories',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/standTransformationHistories/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/standTransformationHistories',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDto>({
      method: 'GET',
      url: `/api/geographic/standTransformationHistories/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/standTransformationHistories/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStandTransformationHistoriesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandTransformationHistoryDto>>({
      method: 'GET',
      url: '/api/geographic/standTransformationHistories',
      params: { standLocationId: input.standLocationId, flowTypeId: input.flowTypeId, description: input.description, inventoryDistributionStatusId: input.inventoryDistributionStatusId, inventoryDistributionDate: input.inventoryDistributionDate, inventoryDistributionUserId: input.inventoryDistributionUserId, inventoryDistributionComment: input.inventoryDistributionComment, activityDistributionStatusId: input.activityDistributionStatusId, activityDistributionDate: input.activityDistributionDate, activityDistributionDateFrom: input.activityDistributionDateFrom, activityDistributionDateTo: input.activityDistributionDateTo, activityDistributionUserId: input.activityDistributionUserId, activityDistributionComment: input.activityDistributionComment, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StandTransformationHistoryExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/standTransformationHistories/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, standLocationId: input.standLocationId, flowTypeId: input.flowTypeId, description: input.description, inventoryDistributionStatusId: input.inventoryDistributionStatusId, inventoryDistributionDate: input.inventoryDistributionDate, inventoryDistributionUserId: input.inventoryDistributionUserId, inventoryDistributionComment: input.inventoryDistributionComment, activityDistributionStatusId: input.activityDistributionStatusId, activityDistributionDate: input.activityDistributionDate, activityDistributionDateFrom: input.activityDistributionDateFrom, activityDistributionDateTo: input.activityDistributionDateTo, activityDistributionUserId: input.activityDistributionUserId, activityDistributionComment: input.activityDistributionComment, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDto[]>({
      method: 'GET',
      url: '/api/geographic/standTransformationHistories/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StandTransformationHistoryUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDto>({
      method: 'PUT',
      url: `/api/geographic/standTransformationHistories/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}